import { VideoCard } from '@/components/partial/video-card';
import { Carousel } from '@/components/shared/carousel';
import { useResourcesIndex } from '@/data/resource-catalog';
import { CardsSkeleton } from '@/packages/home/components/skeleton';

export const VideosSection = () => {
  const videoIds: number[] = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    22, 30, 23, 24, 27, 28, 26, 42, 29, 25, 44, 32, 34, 39, 40, 41, 37, 45, 46,
    68, 48, 50, 51, 53, 54, 55, 56, 59, 60, 61, 62, 63, 58, 64, 65, 66, 67, 69,
    70, 71, 72, 73, 74, 75, 76, 77, 79, 80, 81, 82, 83, 84, 85, 86, 87, 89, 90,
    91, 57, 88, 78, 35, 31, 47, 33, 43, 36, 49, 52, 38,
  ];
  const { data, error, isFetching } = useResourcesIndex({ videoIds });
  const videos = data?.resource?.youtube_video ?? [];

  if (isFetching) return <CardsSkeleton withTextSkeleton={false} />;

  if (error || !videos?.length) return null;

  const slidesComponents = videos?.map((video) => {
    return <VideoCard video={video} key={video.uuid} />;
  });

  return <Carousel slidesComponents={slidesComponents} />;
};
